import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { CacheKeys } from "../../shared/consts/keys.consts"
import { providersService } from "./providers.service"
import type { UpdateProviderInput } from "@montatec/contracts"


type Props = {
  enabled: boolean
}

export function useProviders({enabled} : Props) {
  return useQuery({
    queryKey: CacheKeys.providers,
    queryFn: providersService.get,    
    enabled: enabled
  })
}

export function useProvidersMutations() {
  const qc = useQueryClient()
  
  const createProvider = useMutation({
    mutationFn: providersService.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.providers }),    
  })

  const updateProvider = useMutation({
    mutationFn: ({id, data} : {id: number, data: UpdateProviderInput}) => providersService.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.providers }),
  })
    
  const deleteProvider = useMutation({
    mutationFn: providersService.delete,
    onSuccess: () => qc.invalidateQueries({ queryKey: CacheKeys.providers }),    
  })

  return { createProvider, updateProvider, deleteProvider }
}
